import SwiperCore, { Pagination } from 'swiper'

import { Swiper, SwiperSlide } from 'swiper/react'
import { ThemeProvider } from 'styled-components'

import Spinner from 'builder/components/Spinner'
import { componentsMap, Icons } from './config'
import {
  ProgressBarContainer,
  ProgressBarFiller,
  ServiceHeader,
  ServiceInfo,
  WidgetContainer,
  SwiperListItem,
  CarouselContainer,
  CustomPagination,
} from './styles'
import { Service } from './types'

SwiperCore.use([Pagination])

const swiperStyles = {
  width: '90%',
  padding: '5px',
  display: 'flex',
  flexDirection: 'column',
  gap: '24px',
} as const

export default function MobileAndTable(props: {
  data: Service[]
  setActiveServiceId: (id: string) => void
  activeServiceId: string
  isFetching: boolean
  ProgressModalTrigger: React.ReactNode
  categoryId?: string
}) {
  const { data, setActiveServiceId, activeServiceId, isFetching, ProgressModalTrigger } = props
  return (
    <CarouselContainer>
      <Swiper
        loop={true}
        loopedSlides={data.length}
        pagination={{ el: '.my-custom-pagination', clickable: true }}
        initialSlide={data.findIndex(s => s.id === activeServiceId)}
        centeredSlides={true}
        direction="horizontal"
        slidesPerView="auto"
        spaceBetween={4}
        onSlideChange={swiper => {
          const id = data[swiper.realIndex]?.id
          if (id) setActiveServiceId(id)
        }}
      >
        {data.map(service => {
          const isActive = activeServiceId === service.id
          const { formattedProgress = '', percentageProgress = 0 } = service.calculatedProgress
          const Widget = isFetching ? componentsMap.Default : componentsMap[service.component]

          return (
            <SwiperSlide key={service.id} style={swiperStyles}>
              <ThemeProvider key={service.id} theme={service.theme}>
                <SwiperListItem isActive={isActive} onClick={() => setActiveServiceId(service.id)}>
                  <Icons service={service} isActive={isActive} isLoading={isFetching} />
                  <ServiceInfo>
                    <ServiceHeader>
                      <span>{service.title}</span>
                      <span>
                        {isFetching ? <Spinner $width="24px" $height="24px" /> : formattedProgress}
                      </span>
                    </ServiceHeader>
                    <ProgressBarContainer isActive={isActive}>
                      <ProgressBarFiller progress={percentageProgress} />
                    </ProgressBarContainer>
                  </ServiceInfo>
                  {ProgressModalTrigger}
                </SwiperListItem>
              </ThemeProvider>

              <WidgetContainer>
                <Widget service={service} categoryId={props.categoryId} />
              </WidgetContainer>
            </SwiperSlide>
          )
        })}
      </Swiper>
      <CustomPagination className="my-custom-pagination" />
    </CarouselContainer>
  )
}
